import { pickBy } from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { variant, borderBottom, borderColor, alignItems, AlignItemsProps } from 'styled-system';
import { Link as RouterLink, LinkProps, NavLink as RouterNavLink, NavLinkProps } from 'react-router-dom';

import { basicTheme } from 'src/theme';
import { textBoxStyles, TextBoxProps } from './Text';

export const deleteFalsyKeys = obj => pickBy(obj, Boolean);

export const BaseStyledLink = styled.a`
  color: inherit;
  cursor: pointer;
  text-decoration: none;

  &.disabled {
    pointer-events: none;
  }
`;

export type StyledLinkProps = TextBoxProps &
  AlignItemsProps & {
    variant?: keyof typeof basicTheme.links;
    activeStyle?: Record<string, any>;
    openInNewTab?: boolean;
  };

const linkStyle = variant({
  key: 'links'
});

export const BaseLink = styled(({ openInNewTab, ...rest }) => <BaseStyledLink {...rest} />).attrs(
  ({ openInNewTab }: StyledLinkProps) =>
    deleteFalsyKeys({
      rel: openInNewTab && 'noopener noreferrer',
      target: openInNewTab && '_blank'
    })
)`
  display: flex;
  align-items: center;
  ${linkStyle};
  ${alignItems};
  ${textBoxStyles};
  ${borderBottom};
  ${borderColor};
`;

export const ExternalLink = BaseLink;

type RouterLinkProps = StyledLinkProps & Omit<LinkProps, 'css'>;
export const Link = ({ as = RouterLink, ...props }: RouterLinkProps) => <BaseLink forwardedAs={as} {...props} />;

type RouterNavLinkProps = StyledLinkProps & Omit<NavLinkProps, 'css'>;
export const NavLink = ({ as = RouterNavLink, ...props }: RouterNavLinkProps) => (
  <BaseLink forwardedAs={as} {...props} />
);
